import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLifecycle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 47,
	viewBox: "0 0 42 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 42,
			y: 46.1797,
			width: 11.1198,
			height: 11.1198,
			rx: 1,
			transform: "rotate(-180 42 46.1797)",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.1201,
			y: 28.7451,
			width: 11.1198,
			height: 11.1198,
			rx: 1,
			transform: "rotate(-180 11.1201 28.7451)",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42,
			y: 28.7451,
			width: 11.1198,
			height: 11.1198,
			rx: 1,
			transform: "rotate(-180 42 28.7451)",
			fill: "#94A3B8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42,
			y: 11.3369,
			width: 11.1198,
			height: 11.1198,
			rx: 1,
			transform: "rotate(-180 42 11.3369)",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.44824 15.2188L5.44824 12.8903C5.44824 8.47201 9.02996 4.89029 13.4482 4.89029L26.8997 4.89029",
			stroke: "#395566",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9236 4.71875L23.7236 7.71875L23.7236 1.71875L27.9236 4.71875Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.62598 16.243L2.62598 12.043L8.62598 12.043L5.62598 16.243Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.70605 30.749L5.70605 32.7439C5.70605 37.1621 9.28778 40.7439 13.7061 40.7439H28.3409",
			stroke: "#395566",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5581 40.8193L24.9785 37.8193L24.9785 43.8193L29.5581 40.8193Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00977 29.2234L3.00977 33.0752L9.00977 33.0752L6.00977 29.2234Z",
			fill: "#395566"
		})
	]
});
export default SvgLifecycle;
